import '@fortawesome/fontawesome-free/css/all.css';

import Common from './base/common';

import '../scss/_index.scss';
import '../vue/local-office-info';
import '../vue/location-search';
import '../vue/online-scheduling';
import '../vue/form-contact-us';
import '../vue/next-available';
import '../vue/form-request-appointment';
import '../vue/app';

const common = new Common();
common.init();

// const layout = new Layout();
// layout.init();
